import { createTheme } from "@uifabric/styling";
const myTheme = createTheme({
  palette: {
    themePrimary: "#007deb",
    themeLighterAlt: "#f4f9fe",
    themeLighter: "#d3e9fc",
    themeLight: "#aed6f9",
    themeTertiary: "#61aff3",
    themeSecondary: "#1c8ced",
    themeDarkAlt: "#0071d3",
    themeDark: "#005fb2",
    themeDarker: "#004683",
    neutralLighterAlt: "#faf9f8",
    neutralLighter: "#f3f2f1",
    neutralLight: "#edebe9",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c6c4",
    neutralTertiary: "#a19f9d",
    neutralSecondary: "#605e5c",
    neutralPrimaryAlt: "#3b3a39",
    neutralPrimary: "#323130",
    neutralDark: "#201f1e",
    black: "#000000",
    white: "#ffffff",
  },
});
export default myTheme;
